// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2P1So","icon":"SortAdornment_icon__2Rz-M","up":"SortAdornment_up__3b3qx","down":"SortAdornment_down__N2XWB","active":"SortAdornment_active__1XrXZ"};